<template>
  <div class="home">
    <!-- 背景 -->
    <div class="back">
    </div>
    <!-- 教育资源 -->
    <div class="goodss">
      <h6 class="titles">
        师资汇聚，实战经验倾囊相授
        <div class="eng">Team</div>
      </h6>
      <div><img class="teacher" src="../../img/newteacher.jpg" alt=""></div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: '1',
      backgroundColor: '',
      Activeindex: '0',
      arr: ['滑步车', '跳绳', '篮球', '体操', '田径', '跑酷']
    }
  },
  methods: {
    handleJump () {
      this.componentId = this.componentName[this.activeIndex]
      // this.$router.push('./trochlear')
    },
    activeHandle (index) {
    // 把我们自定义的下标赋值
      this.activeIndex = index
    },
    handleSelect (key, keyPath) {
      console.log(key, 'keykey')
      console.log(this.activeIndex, 'activeIndex')
      this.activeIndex = key
      console.log(key, keyPath)
    },
    index () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
body{
  margin: 0
}
/* 顶部 */
.top{
  height: 135px;
}
.logoimg{
  width: 1210px;
  height: 135px;
  margin:0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.phone{
  display: flex;
}
.callme{
  padding-top: 5px;
  display: inline;
}
.callphone{
  font-weight: 700;
}
.call{
  font-size: 32px;
  font-weight: 700;
  color: #EB2F2F;
}
img{
  width: 180px;
  height: 135px;
}
.el-icon-phone{
    margin-top: 30px  ;
    font-size: 67px;
  }
/* tab */
.el-menu-demo{
  padding-left: 348px;
}
.tab{
  display: flex;
  height: 60px;
  background-color: pink;
}
.tabbox{
  width: 104px;
  height: 60px;
  background-color: skyblue;
}
.txt{
  font-size: 16px;
}
.txt01 {
    font-size: 16px;
    padding: 0 20px;
  }
:deep .el-submenu__title {
  padding: 0 !important;
}
.el-submenu__title{
  padding: 0 !important;
}
.active-background{
  background-color: red !important;
  color:#FFF!important;
}
/* 背景 */
.back{
  width: 100%;
  height: 390px;
  background-image: url(../../img/师资背景图.jpg);
}
/* 教育资源 */
.goodss{
  width: 1210px;
  margin:0 auto;
  padding-bottom: 80px;
}
.teacher{
    width: 1210px;
    height: 650px ;
    margin: 0 auto
  }
.title{
  height: 150px;
  font-size: 38px;
  padding-top: 40px;
  padding-bottom: 25px;
  text-align: center;
  color: #fff;
}
/* 教育 */
.titles{
  color: #000;
  height: 150px;
  font-size: 38px;
  padding-top: 40px;
  text-align: center;
}
/* tab */
.taab{
  display: flex;
  height: 60px;
  padding-left: 348px;
  background-color: #A01C64;
}
.tabtxt{
  width: 100px;
  height: 60px;
  display: flex;
  justify-content: center;
  line-height: 60px;
  color: #FFF;
}
.active{
  color: red;
  border-bottom: 1px solid #000;
}
/* 内容 */
.main{
  width: 1210px;
  height: 1200px;
  display: flex;
  margin:130px auto;
  background-color: #fff;
}
.subject{
  margin:0 auto;
  padding-top: 50px;
  background-color: #FABE03   ;
}
.teatxt{
  display: flex;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
}
.stutxt{
  width: 920px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #fff;
}
.txts{
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  margin-top: 10px;
}
.subjie{
  width: 175px;
  height: 75px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #A01C64;
}

</style>
